module.exports = __webpack_public_path__ + "static/media/node-js-logo-mobile.a5f892bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/node-js-logo-mobile.png
// module id = 64
// module chunks = 0